export function isV2OrganisationsAndRolesCopyContext(pathname: string): boolean {
  return pathname === '/v2' || pathname.startsWith('/v2/')
}

export function associatedPartiesCopyKey(pathname: string, key: string): string {
  if (isV2OrganisationsAndRolesCopyContext(pathname)) {
    return `v2.${key}`
  }
  return key
}

export function productCatalogManufacturerCopyKey(
  pathname: string,
  key: string
): string {
  if (isV2OrganisationsAndRolesCopyContext(pathname)) {
    return `v2.manufacturerSelect.${key}`
  }
  return key
}
